import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styles from './TeacherMissionMonitoring.module.css';

const TeacherMissionMonitoring = ({ missionId }) => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStudentProgress = async () => {
      try {
        const response = await axios.get(`/api/missions/${missionId}/students`);
        if (response.data.success) {
          setStudents(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching student progress:', error);
      } finally {
        setLoading(false);
      }
    };

    if (missionId) {
      fetchStudentProgress();
    }
  }, [missionId]);

  if (loading) {
    return <div className={styles.loading}>Loading student progress...</div>;
  }

  return (
    <div className={styles.monitoringContainer}>
      <h3 className={styles.monitoringTitle}>Student Progress</h3>
      {students.length === 0 ? (
        <div className={styles.noStudents}>
          <p>No students have been assigned to this mission yet.</p>
        </div>
      ) : (
        <div className={styles.studentList}>
          {students.map((student) => (
            <div key={student._id} className={styles.studentCard}>
              <div className={styles.studentInfo}>
                <h4 className={styles.studentName}>{student.contactName}</h4>
                <span className={`${styles.statusBadge} ${styles[student.status]}`}>
                  {student.status}
                </span>
              </div>
              
              <div className={styles.progressDetails}>
                <div className={styles.progressRow}>
                  <span className={styles.progressLabel}>Progress:</span>
                  <span className={styles.progressValue}>{student.progress}%</span>
                </div>
                
                {student.progressData && student.progressData.completedTasks && (
                  <div className={styles.progressRow}>
                    <span className={styles.progressLabel}>Tasks Completed:</span>
                    <span className={styles.progressValue}>
                      {student.progressData.completedTasks.length}/4
                    </span>
                  </div>
                )}
                
                {student.score > 0 && (
                  <div className={styles.progressRow}>
                    <span className={styles.progressLabel}>Score:</span>
                    <span className={styles.progressValue}>{student.score} points</span>
                  </div>
                )}
                
                <div className={styles.progressRow}>
                  <span className={styles.progressLabel}>Viewed:</span>
                  <span className={styles.progressValue}>
                    {student.viewed ? 'Yes' : 'No'}
                  </span>
                </div>
                
                {student.viewedAt && (
                  <div className={styles.progressRow}>
                    <span className={styles.progressLabel}>Viewed At:</span>
                    <span className={styles.progressValue}>
                      {new Date(student.viewedAt).toLocaleString()}
                    </span>
                  </div>
                )}
                
                {student.lastSaved && (
                  <div className={styles.progressRow}>
                    <span className={styles.progressLabel}>Last Saved:</span>
                    <span className={styles.progressValue}>
                      {new Date(student.lastSaved).toLocaleString()}
                    </span>
                  </div>
                )}
              </div>
              
              <div className={styles.progressBar}>
                <div 
                  className={styles.progressFill}
                  style={{ width: `${student.progress}%` }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TeacherMissionMonitoring; 